import { render, staticRenderFns } from "./facepayrecord.vue?vue&type=template&id=1fe87694&scoped=true&"
import script from "./facepayrecord.vue?vue&type=script&lang=js&"
export * from "./facepayrecord.vue?vue&type=script&lang=js&"
import style0 from "./facepayrecord.vue?vue&type=style&index=0&id=1fe87694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe87694",
  null
  
)

export default component.exports